<template>
  <div>
    <headerIndex
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
      v-on:map="currentView='map'"
    ></headerIndex>
    <template v-if="currentView ==='grid' && path === '/agro'">
      <agroGrid></agroGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/agro'">
      <agroList></agroList>
    </template>
    <template v-if="currentView === 'map' && path === '/agro'">
      <agroMap></agroMap>
    </template>
    <template v-if="currentView === 'grid' && path === '/airflow'">
      <airflowGrid></airflowGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/airflow'">
      <airflowList></airflowList>
    </template>
    <template v-if="currentView === 'map' && path === '/airflow'">
      <airflowMap></airflowMap>
    </template>
    <template v-if="currentView === 'grid' && path === '/doors'">
      <doorsGrid></doorsGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/doors'">
      <doorsList></doorsList>
    </template>
    <template v-if="currentView === 'map' && path === '/doors'">
      <doorsMap></doorsMap>
    </template>
    <template v-if="currentView === 'grid' && path === '/env'">
      <envGrid></envGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/env'">
      <envList></envList>
    </template>
    <template v-if="currentView === 'map' && path === '/env'">
      <envMap></envMap>
    </template>
    <template v-if="currentView === 'grid' && path === '/energy'">
      <energyGrid></energyGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/energy'">
      <energyList></energyList>
    </template>
    <template v-if="currentView === 'map' && path === '/energy'">
      <energyMap></energyMap>
    </template>
    <template v-if="currentView === 'grid' && path === '/labels'">
      <labelsGrid></labelsGrid>
    </template>
    <template v-if="currentView === 'list' && path === '/labels'">
      <labelsList></labelsList>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@/components/headerIndex/headerIndex.vue'),
    agroGrid: () => import('./Agro/Grid.vue'),
    agroList: () => import('./Agro/List.vue'),
    agroMap: () => import('./Agro/Map.vue'),
    airflowGrid: () => import('./AirFlow/Grid.vue'),
    airflowList: () => import('./AirFlow/List.vue'),
    airflowMap: () => import('./AirFlow/Map.vue'),
    doorsGrid: () => import('./Doors/Grid.vue'),
    doorsList: () => import('./Doors/List.vue'),
    doorsMap: () => import('./Doors/Map.vue'),
    envGrid: () => import('./EnvTemp/Grid.vue'),
    envList: () => import('./EnvTemp/List.vue'),
    envMap: () => import('./EnvTemp/Map.vue'),
    energyGrid: () => import('./Energy/Grid.vue'),
    energyList: () => import('./Energy/List.vue'),
    energyMap: () => import('./Energy/Map.vue'),
    labelsGrid: () => import('./SmartLabels/Grid.vue'),
    labelsList: () => import('./SmartLabels/List.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>
